module.exports = __webpack_public_path__ + "static/img/pi-point.edeee1b8.svg";